import { render, staticRenderFns } from "./stu.vue?vue&type=template&id=d5145350&scoped=true&"
import script from "./stu.vue?vue&type=script&lang=js&"
export * from "./stu.vue?vue&type=script&lang=js&"
import style0 from "./stu.vue?vue&type=style&index=0&id=d5145350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5145350",
  null
  
)

export default component.exports